import {
  Typography,
  List,
  ListItemText,
  ListItem,
  Paper,
  makeStyles,
  Grid,
} from "@material-ui/core";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ExpansionApplicationListState } from "../../redux/state";
import { distanceAgo } from "@ofqual/portal-core/core/utils/dateUtils";
import { ScopeApplicationState } from "../../domain/ScopeApplication";

const SEARCH_STATE_KEY = "search";

const useStyles = makeStyles((theme) => ({
  submissionRowDetails: {
    paddingRight: "20px",
  },
}));

export const ApplicationsList: React.FC<{
  state: ExpansionApplicationListState;
}> = ({ state }) => {
  const classes = useStyles();

  const { response } = state;
  const history = useHistory();
  const { pathname, search } = useLocation();
  const navigate = (id: string) =>
    history.push(`${pathname}/${id}`, { [SEARCH_STATE_KEY]: search });

  return (
    <Paper>
      <List disablePadding>
        {response.data.map((item, index) => (
          <React.Fragment key={item.id}>
            <ListItem
              button
              alignItems="flex-start"
              onClick={() => navigate(`applications/${item.id}`)}
              divider
              data-test="row"
            >
              <ListItemText
                primary={
                  <Typography component="span" variant="h6" color="textPrimary">
                    {item.title}
                  </Typography>
                }
                secondary={
                  <Grid container spacing={3} component="span">
                    <Grid item component="span">
                      {item.submittedAt ? (
                        <>
                          <Typography
                            className={classes.submissionRowDetails}
                            component="span"
                            variant="body2"
                            color="textPrimary"
                          >
                            <strong>Submitted: </strong>
                            {distanceAgo(item.submittedAt)}
                          </Typography>
                          <Typography
                            className={classes.submissionRowDetails}
                            component="span"
                            variant="body2"
                            color="textPrimary"
                          >
                            <strong>Submitted By:</strong>{" "}
                            {item.submittedByName}
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Typography
                            className={classes.submissionRowDetails}
                            component="span"
                            variant="body2"
                            color="textPrimary"
                          >
                            <strong>Created: </strong>
                            {distanceAgo(item.createdAt)}
                          </Typography>
                          <Typography
                            className={classes.submissionRowDetails}
                            component="span"
                            variant="body2"
                            color="textPrimary"
                          >
                            <strong>Created By:</strong> {item.createdByName}
                          </Typography>
                        </>
                      )}
                      <Typography
                        className={classes.submissionRowDetails}
                        component="span"
                        variant="body2"
                        color="textPrimary"
                      >
                        <strong>Last Updated: </strong>
                        {distanceAgo(item.updatedAt)}
                      </Typography>
                      {item.updatedByName && (
                        <Typography
                          className={classes.submissionRowDetails}
                          component="span"
                          variant="body2"
                          color="textPrimary"
                        >
                          <strong>Updated By:</strong> {item.updatedByName}
                        </Typography>
                      )}
                      {item.assignedToDisplayName && (
                        <Typography
                          className={classes.submissionRowDetails}
                          component="span"
                          variant="body2"
                          color="textPrimary"
                        >
                          <strong>Assigned To:</strong>{" "}
                          {item.assignedToDisplayName}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item style={{ marginLeft: "auto" }} component="span">
                      <Typography
                        className={classes.submissionRowDetails}
                        component="span"
                        variant="body2"
                        color="textPrimary"
                      >
                        <strong>Status: </strong>
                        {ScopeApplicationState[item.state]}
                      </Typography>
                    </Grid>
                  </Grid>
                }
              />
            </ListItem>
          </React.Fragment>
        ))}
      </List>
    </Paper>
  );
};
